import React,{useState,useEffect,useRef}from 'react'
import { Modal,Form,Input, App, } from 'antd';
import Icon from '../../../cpn/Icon';
import { useFeiyongTypeUpdateSaveMutation } from '../../../store/DianShangYeWuApi';     
function ExpenseTypeEdit(props) {
    console.log(props);
    const { message } = App.useApp();
    const [form] = Form.useForm();
    const [open, setOpen] = useState(false);
    const onCreateEdit = (values) => {
        // console.log('Received values of form: ', values);
        setOpen(false);
    };
    const [info,setInfo] = useState({
        fyt_name:props.fyt_name,      
        fyt_qy_id:props.qy_id,
        fyt_qy_name:props.qy_name,
        fyt_uid:props.yh_id,
        fyt_uname:props.yh_name,
        fyt_id:props.fyt_id,
    }); 
    const editForm = useRef()
    useEffect(() => {
        if(editForm.current){   
            editForm.current.setFieldsValue({
                fyt_name:props.fyt_name,
            })   
        }
    },[open ,props.fyt_name])
    const [fytEdit] = useFeiyongTypeUpdateSaveMutation()    
    return (
        <>
            <Icon type='edit' onClick={() => {setOpen(true)}} />
            <Modal
                width={1000}                        
                open={open}
                title='修改费用类型'
                okText="保存"
                cancelText="取消"
                onCancel={() => {setOpen(false);}}
                onOk={() => {                    
                    form
                        .validateFields()
                        .then((values) => {
                            fytEdit(info).then((res) => {
                                // console.log(res);
                                if (res.data.Status === 'success') {
                                    message.success('修改成功')   
                                    setOpen(false);
                                    form.resetFields();
                                    onCreateEdit(values);
                                }
                                if (res.data.Status === 'fail') {
                                    message.error('修改失败：'+res.data.Message)
                                }
                            })
                        })
                        .catch((info) => {
                            // console.log('Validate Failed:', info);
                        });
                }}
            >
                <Form
                    form={form}
                    layout="horizonal"
                    name={`form_fyt_edit_${props.yh_id}`}
                    initialValues={{modifier: 'public',}}
                    labelCol={{ span: 3 }}
                    ref={editForm}
                >                    
                    <Form.Item name="fyt_name" wrapperCol={{span:4}} required label='名称'>                        
                        <Input onChange={(e) => {
                            setInfo(prevState=>({...prevState,fyt_name:e.target.value}))
                        }}/>
                    </Form.Item>                                           
                </Form>
            </Modal>
        </>
    )
}

export default ExpenseTypeEdit